import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import LocationField from '../create/LocationField';
import ContactField from './ContactField';
class LocationDetails extends Component {
    constructor() {
        super(...arguments);
        this.handleFieldChange = (field) => this.props.onChange(field);
        this.handleAddContact = () => this.props.onAddContact();
        this.handleRemoveContact = (i) => () => this.props.onRemoveContact(i);
        this.handleContactFieldChange = (i) => (field, value) => {
            this.props.onContactFieldChange(i, field, value);
        };
        this.handleLocationAddressSelect = (item) => {
            this.props.onAddressChange(item.address);
        };
    }
    renderLocationFields() {
        const { errors, action_type, name, address, t } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("fieldset", { className: "md:mr-2" },
                    React.createElement("label", { className: "form-label block mb-2" }, titleize(t('ACTION'))),
                    React.createElement("select", { className: "form-select mb-4", value: action_type.toLowerCase(), onChange: this.handleFieldChange('action_type') },
                        React.createElement("option", { value: "pickup" }, titleize(t('PICKUP'))),
                        React.createElement("option", { value: "deliver" }, titleize(t('DELIVERY'))),
                        React.createElement("option", { value: "pickup_empty" }, titleize(t('PICKUP_EMPTY'))),
                        React.createElement("option", { value: "deliver_empty" }, titleize(t('DELIVERY_EMPTY')))))),
            React.createElement("div", null,
                React.createElement("div", { className: "w-full" },
                    React.createElement("fieldset", { className: "md:mr-2" },
                        React.createElement("label", { className: "form-label mb-2 block" }, t('NAME')),
                        React.createElement("input", { id: this.props.locationNameId, className: "form-field mb-4 w-full block", value: name, placeholder: t('NAME'), onChange: this.handleFieldChange('name') }))),
                React.createElement("div", { className: "w-full" },
                    React.createElement("fieldset", { className: "md:mr-2 mb-4" },
                        React.createElement(LocationField, { locationAddressId: this.props.locationAddressId, key: address, onAddressSelect: this.handleLocationAddressSelect, error: errors.hasOwnProperty('address'), address: address }))),
                React.createElement("div", { className: "w-full" },
                    this.renderContacts(),
                    React.createElement("button", { className: "mb-4 button button-hollow-green", onClick: this.handleAddContact },
                        React.createElement("i", { className: "fa fa-plus mr-2" }),
                        React.createElement("span", null, titleize(t('CONTACT', { count: 1 }))))))));
    }
    renderContacts() {
        const { contacts, t } = this.props;
        return (React.createElement("div", { className: "contacts mb-4" },
            React.createElement("label", { className: "mb-2 form-label" }, titleize(t('CONTACT', { count: 2 }))),
            contacts.map((contact, i) => (React.createElement(ContactField, { contact: contact, key: i, onChange: this.handleContactFieldChange(i), onRemove: this.handleRemoveContact(i) })))));
    }
    render() {
        const { sectionTitle } = this.props;
        return (React.createElement("section", { className: "mb-4" },
            React.createElement("h4", { className: "text-grey-dark" }, sectionTitle),
            this.renderLocationFields()));
    }
}
LocationDetails.propTypes = {
    locationNameId: PropTypes.string,
    locationAddressId: PropTypes.string,
    sectionTitle: PropTypes.string,
    action_type: PropTypes.string,
    name: PropTypes.string,
    errors: PropTypes.object,
    address: PropTypes.string,
    contacts: PropTypes.array,
    onAddressChange: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onContactFieldChange: PropTypes.func.isRequired,
    onAddContact: PropTypes.func.isRequired,
    onRemoveContact: PropTypes.func.isRequired,
};
LocationDetails.defaultProps = {
    errors: {},
};
export default withTranslation()(LocationDetails);
